import { IMAGES, DEFAULT_WA_MESSAGE, whatsappLink } from "@/constants/site";

const TRUST_ITEMS = [
  { icon: "ri-leaf-line", label: "Doğayla İç İçe" },
  { icon: "ri-home-4-line", label: "Bungalov Konaklama" },
  { icon: "ri-restaurant-2-line", label: "Restaurant & Wellness" },
];

export default function Hero() {
  const waLink = whatsappLink(DEFAULT_WA_MESSAGE);

  return (
    <section id="top" className="relative w-full h-[92vh] min-h-[620px] overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.exterior}
          alt="Düzbağ Life A-frame bungalovları ve dağ manzarası"
          title="Düzbağ Life bungalov konaklama Kahramanmaraş"
          className="w-full h-full object-cover object-top hero-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-foreground-950/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-8">
        <span className="text-accent-300 text-xs md:text-sm tracking-[0.35em] uppercase mb-5">
          Çağlayancerit · Kahramanmaraş
        </span>
        <h1 className="font-heading text-background-50 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium leading-[1.05] tracking-wide max-w-4xl">
          DOĞANIN İÇİNDE
          <br />
          KENDİNİZE AİT BİR KAÇIŞ
        </h1>
        <p className="mt-6 text-background-100/90 text-sm md:text-base lg:text-lg leading-relaxed max-w-2xl">
          Dağların, yeşilin ve akarsuyun buluştuğu Düzbağ Life'ta konaklamadan
          lezzete, dinlenmeden wellness deneyimine kadar her şey doğanın ritmine
          uyum sağlıyor.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center gap-3 sm:gap-4 w-full sm:w-auto">
          <a
            href="#bungalovlar"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-50 text-foreground-950 font-semibold px-7 py-3.5 rounded-md whitespace-nowrap transition-transform hover:-translate-y-0.5 cursor-pointer"
          >
            Bungalovları Keşfet
            <i className="ri-arrow-right-line" />
          </a>
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-950/40 backdrop-blur-sm border border-background-50/40 text-background-50 font-semibold px-7 py-3.5 rounded-md whitespace-nowrap transition-colors hover:bg-background-950/60 cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg" />
            WhatsApp'tan Rezervasyon
          </a>
        </div>

        {/* Trust indicators */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-6 w-full max-w-3xl">
          {TRUST_ITEMS.map((item) => (
            <div
              key={item.label}
              className="flex items-center justify-center gap-3 bg-background-50/10 backdrop-blur-sm border border-background-50/15 rounded-lg px-5 py-3.5"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500/20 text-accent-300">
                <i className={`${item.icon} text-lg`} />
              </span>
              <span className="text-background-50 text-sm font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-7 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 z-10">
        <span className="text-background-200/70 text-[10px] tracking-[0.3em] uppercase">
          Keşfet
        </span>
        <span className="relative w-px h-12 overflow-hidden scroll-line" />
      </div>
    </section>
  );
}